import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { getWhatsAppUrl, CLINIC_NAME } from "@/lib/constants";
import Breadcrumbs from "@/components/Breadcrumbs";
import CTABanner from "@/components/CTABanner";
import BeforeAfterCarousel from "@/components/BeforeAfterCarousel";

const SmileGallery = () => {
  return (
    <div>
      <section className="bg-secondary py-12 md:py-16">
        <div className="container">
          <Breadcrumbs items={[{ label: "Smile Gallery" }]} />
          <h1 className="font-heading text-3xl md:text-4xl font-light text-secondary-foreground mb-3">Real Smiles, Real Results</h1>
          <p className="text-secondary-foreground/80 max-w-2xl">
            See the amazing smile transformations achieved by our patients at {CLINIC_NAME}. Every smile tells a story.
          </p>
        </div>
      </section>

      <BeforeAfterCarousel
        showFilters
        eyebrow="SMILE GALLERY"
        heading="Every smile, a story."
        subheading="Filter by treatment to see real before-and-after cases from our clinic."
      />

      <div className="container pb-16 text-center">
        <p className="text-xs text-muted-foreground italic mb-6">
          Results may vary. All photos shared with patient consent.
        </p>
        <Button asChild className="max-w-full h-auto min-h-12 whitespace-normal tracking-normal py-3 px-4">
          <a href={getWhatsAppUrl("Hi, I'd like to discuss smile transformation options.")} target="_blank" rel="noopener noreferrer">
            <MessageCircle className="h-5 w-5 mr-2" /> Want Similar Results? Chat with Us
          </a>
        </Button>
      </div>

      <CTABanner />
    </div>
  );
};

export default SmileGallery;
